export default class Category {
    constructor({
        id = 0,
        name = '',
        pictureUrl = '',
        duration = '',
        startsAt = '',
        venue = {},
        isActive = false,
        demandBannerEnabled = true,
        categories = [],
        createdAt = '',
        updatedAt = '',
    } = {}) {
        this.id = id;
        this.name = name;
        this.pictureUrl = pictureUrl;
        this.duration = duration;
        this.startsAt = startsAt;
        this.venue = venue;
        this.isActive = isActive;
        // Apagado del banner de señal de demanda (HU #8). Default `true`: el
        // backend lo trae encendido y solo se apaga a mano.
        this.demandBannerEnabled = demandBannerEnabled;
        this.categories = categories;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}
